__turbopack_context__.v({
  "desktop": "LoyaltyPriceDisplay-module__xnOmwG__desktop",
  "discountedPrice": "LoyaltyPriceDisplay-module__xnOmwG__discountedPrice",
  "originalPrice": "LoyaltyPriceDisplay-module__xnOmwG__originalPrice",
  "priceRow": "LoyaltyPriceDisplay-module__xnOmwG__priceRow",
  "total": "LoyaltyPriceDisplay-module__xnOmwG__total",
});
